import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-declaration-accessibilite',
  templateUrl: './declaration-accessibilite.component.html',
  styleUrls: ['./declaration-accessibilite.component.scss'],
  standalone: true
})
export class DeclarationAccessibiliteComponent {

  constructor() { }

}
